// extracted by mini-css-extract-plugin
export default {"tooltip__content":"tooltip_tooltip__content__smdrY"};